import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-mp-toggle',
  templateUrl: './mp-toggle.component.html',
  imports: [TranslateModule, FormsModule],
  styleUrl: './mp-toggle.component.scss'
})
export class MpToggleComponent {
  @Input() public label: string;
  @Input() public toggleState: boolean;
  @Input() public disabled: boolean = false;

  @Output() public toggleStateChange = new EventEmitter<boolean>();

  public modeSwitch(value: boolean) {
    if (this.disabled) {
      return;
    }

    this.toggleState = value;
    this.toggleStateChange.emit(value);
  }
}
